export default (state, {payload}) => (payload({...state}));
